import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		textarea: {
			border: "1px solid #ccc",
			display: "flex",
			height: "100%",
			lineHeight: 1.42,
			outline: "none",
			overflowY: "auto",
			padding: "12px 15px",
			resize: "none",
			tabSize: 4,
			textAlign: "left",
			whiteSpace: "pre-wrap",
			width: "100%",
			wordWrap: "break-word",
		},
	} satisfies Record<string, CSSObject>);
